import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VisitorTypeComponent } from './visitorType.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  declarations: [VisitorTypeComponent],
  exports: [
    VisitorTypeComponent
  ],
  providers: [
  ]
})
export class VisitorTypeModule { }
